<template>
  <div>
    <router-view v-if="routeReady" />
    <Loading v-else />
  </div>
</template>

<script>
import routeReady from '@/mixins/routeReady'

export default {
  mixins: [ routeReady ]
}
</script>
